import { useContext } from "react";
import { WorkspaceContext } from "./WorkspaceContext.tsx";

export function getTenantAssessmentPaths(workspaceId?: string) {
    const root = workspaceId ? `/app/${workspaceId}/tenant-assessment` : "/app/tenant-assessment";

    return {
        root,
        setup: `${root}/setup`,
        home: workspaceId ? `/app/${workspaceId}/home` : "/app/home",
        reportsGenerate: workspaceId ? `/app/${workspaceId}/reports/ai-generate` : "/app/reports/ai-generate"
    };
}

export function useTenantAssessmentPaths() {
    const workspaceContext = useContext(WorkspaceContext);

    return getTenantAssessmentPaths(workspaceContext?.currentWorkspace?.id);
}

export interface GenerateAiReportLocationState {
    prompt: string;
}

export function readGenerateAiReportPrompt(state: unknown) {
    if (typeof state !== "object" || state === null || !("prompt" in state)) {
        return undefined;
    }

    return typeof state.prompt === "string" ? state.prompt : undefined;
}
